import { render, staticRenderFns } from "./BaseDialogSign.vue?vue&type=template&id=1ff4b714"
import script from "./BaseDialogSign.vue?vue&type=script&lang=js"
export * from "./BaseDialogSign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports